<template>
  <div>
    <div class="stylist-actions">
      <div @click="goToAction(stylistAction)" v-bind:key="stylistAction.key" v-for="(stylistAction, key) in stylistActions" class="stylist-action">
        <i :class="stylistAction.icon"></i>
        <p>{{ key }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'action-bar',
  data () {
    return {
      stylistActions: {
        Dashboard: {
          icon: 'bx bxs-dashboard',
          url: '/dashboard?go=dashboard'
        },
        Alerts: {
          icon: 'bx bx-bell',
          modalId: 'notifications'
        },
        Clients: {
          icon: 'bx bxs-user-detail',
          url: '/clients'
        },
        Reports: {
          icon: 'bx bx-chart',
          url: '/dashboard?go=commissions'
        },
        Account: {
          icon: 'bx bx-user',
          url: process.env.VUE_APP_FASHIONPHILE_API_URL + '/account/dashboard'
        }
      }
    }
  },
  methods: {
    goToAction (action) {
      if (action.modalId) {
        return this.$bvModal.show(action.modalId + '-modal')
      }
      if (action.url && action.url.includes('http')) {
        return this.externalRedirect(action.url)
      }
      // Just navigate - store's getClients will handle caching
      this.$router.push(action.url)
    },
    externalRedirect (url) {
      const data = {
        userId: this.$store.state.stylist.id,
        url: url
      }
      this.$store.dispatch('authenticateAndRedirect', data)
    }
  }
}
</script>

<style type="text/css">
  .stylist-actions {
    display: flex;
    margin-top: 15px;
    -content: center;
    color: #000;
  }

  .stylist-action {
    margin: auto;
    font-size: 10px;
    text-align: center;
  }

  .stylist-action p {
    font-size: 10px;
    color: #000;
  }

  .stylist-action i {
    font-size: 20px;
    line-height: 18px;
    color: #000;
    cursor: pointer;
  }
</style>
